import { useState, useEffect, useMemo } from "react";
import { Heart } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useFavorites } from "@/context/FavoritesContext";
import { getProperties } from "@/lib/api";
import { PropertiesMap } from "@/components/PropertiesMap";

export const MapSection = () => {
  const { t } = useApp();
  const { favorites } = useFavorites();
  const [points, setPoints] = useState([]);
  const [favOnly, setFavOnly] = useState(false);

  useEffect(() => {
    getProperties({ limit: 100 }).then(setPoints).catch(() => {});
  }, []);

  const shown = useMemo(
    () => (favOnly ? points.filter((p) => favorites.includes(p.slug)) : points),
    [favOnly, points, favorites]
  );

  return (
    <section id="map" className="scroll-mt-24 bg-sand-card py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <p className="overline text-terracotta">{t("sections.map_over")}</p>
            <h2 className="mt-3 font-serif text-4xl font-medium text-petrol lg:text-5xl">{t("sections.map_title")}</h2>
          </div>
          <button
            data-testid="map-favorites-toggle"
            onClick={() => setFavOnly((v) => !v)}
            disabled={!favorites.length}
            className={`flex items-center gap-2 rounded-none border px-4 py-2.5 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${
              favOnly ? "border-terracotta bg-terracotta text-white" : "border-sand-border bg-white text-petrol hover:border-terracotta"
            }`}
          >
            <Heart size={16} className={favOnly ? "fill-current" : ""} />
            {t("search.only_favorites")}
            {favorites.length > 0 && (
              <span className={`rounded-none px-1.5 text-xs ${favOnly ? "bg-white/25" : "bg-terracotta text-white"}`}>
                {favorites.length}
              </span>
            )}
          </button>
        </div>
        <PropertiesMap key={favOnly ? "fav" : "all"} points={shown} height="560px" />
      </div>
    </section>
  );
};
